module.exports = __webpack_public_path__ + "img/step_4-3.293f5de6.png";